<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_20954_19751)">
			<path
				d="M9.81205 25V10.6316L9.23749 9.04783C9.07916 8.61692 9 8.16083 9 7.69074V5.74324C9 4.78348 9.71246 4 10.5909 4H12.4091C13.285 4 14 4.78068 14 5.74324V7.69074C14 8.16083 13.9183 8.61692 13.76 9.04783L13.1854 10.6288V25"
				:stroke="props.iconColor"
				stroke-width="1.6"
			/>
			<path
				d="M12.0344 46H10.9655C9.45492 46 8.04363 45.3984 7.09755 44.3491C6.33963 43.5086 5.95022 42.4483 6.0051 41.366L6.4311 32.9495C6.49905 31.631 7.3798 30.4801 8.70746 29.9472V26.7333C8.70746 25.7774 9.55685 25 10.5996 25H12.4003C13.4431 25 14.2925 25.7774 14.2925 26.7333V29.9472C15.6202 30.4801 16.5009 31.631 16.5689 32.9495L16.9949 41.366C17.0498 42.4483 16.663 43.5086 15.9024 44.3491C14.9563 45.3984 13.5451 46 12.0344 46Z"
				:stroke="props.iconColor"
				stroke-width="1.6"
			/>
			<path
				d="M27.0677 18L26.72 21.7128C26.2431 26.7259 26 31.8368 26 36.9042V42.4993C26 44.4278 27.6215 46 29.6185 46H30.3785C32.3754 46 34 44.4305 34 42.4993V36.9042C34 31.8749 33.7569 26.7612 33.28 21.7128L32.9292 18"
				:stroke="props.iconColor"
				stroke-width="1.6"
			/>
			<path
				d="M27.7958 18H32.2042C34.2961 18 36 16.3553 36 14.3362V8.6638C36 6.64468 34.2961 5 32.2042 5H27.7958C25.7039 5 24 6.64468 24 8.6638V14.3362C24 16.3553 25.7039 18 27.7958 18Z"
				:stroke="props.iconColor"
				stroke-width="1.6"
			/>
			<path
				d="M24 8.45382L20.3035 8.01216C19.7155 7.94363 19.1276 8.167 18.6888 8.62389C18.2523 9.08077 18 9.73818 18 10.421V12.581C18 13.2638 18.2523 13.9187 18.691 14.3781C19.075 14.7792 19.5751 15 20.0885 15H20.0841C20.1565 15 20.2267 14.9949 20.2991 14.9873L23.9956 14.5482"
				:stroke="props.iconColor"
				stroke-width="1.6"
			/>
			<path
				d="M35.5 9C38.5 9 41.5 10 42.9769 13.1181C43.0281 13.2678 42.9923 13.4335 42.8848 13.543C42.7748 13.6526 42.6136 13.6873 42.4728 13.6259C41.5567 13.2384 36.4494 13.5003 35.5 13.9626"
				:stroke="props.iconColor"
				stroke-width="1.6"
			/>
		</g>
		<defs>
			<clipPath id="clip0_20954_19751">
				<rect width="39.4483" height="44" fill="white" transform="translate(5.27734 3)" />
			</clipPath>
		</defs>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
